export const environment = {
    envName: 'local',
    production: false,
    baseUrl: 'https://den.dev.serviceo.me',
    apiVersion: 'api/v1',
    googleMapKey: 'AIzaSyCPgeXNOHOu8A5XTu3rCkoivQRHJHkD0LA',
    osmMapKey: 'pk.eyJ1IjoiZ2F1cmF2bGFtYmhhIiwiYSI6ImNrYXhlcnFmZzA0Mmkyc252a21qZjl5cmYifQ.Resf0dshcGXNBekmsfHN0A',
    websocket: 'ws://localhost:3000',
    rtUrl: 'https://rt.dev.serviceo.me',
    communityUrl: 'https://serviceo.azurewebsites.net',
    gTag_msp: 'G-B6C4EK5P1R',
    gTag_community: 'G-4ZE8S2JP8L',
    notificationUrl: 'http://localhost:3333',
    auth: {
        CLIENT_ID: 'BB1cQd8IaVDtgsDL7G57XyzSxu6cb4It',
        CLIENT_DOMAIN: 'serviceo-dev.auth0.com',
        AUDIENCE: 'https://den.dev.serviceo.me/api/v1/',
        REDIRECT: 'https://serviceo.azurewebsites.net/callback',
        LOGOUT_URL: 'https://serviceo.azurewebsites.net',
        SCOPE: 'openid email profile app_metadata'
    },
    fileUpload: {
        maxFileSize: 20971520, //maximum file size allowed for upload (20 MB)
        maxFileLimit: 5
    },
    microsoftAccountId: '0018A00000VQJaEQAX'
};